import Course from '@/models/list/Course';
import Unit from '@/models/list/Unit';

import { COURSE_SERVICE } from '@/modules/CourseManagement/constants';

import APIService from '@/services/APIService';

export default {

  index(params, serviceType = COURSE_SERVICE.all) {
    const SERVICES = {
      [COURSE_SERVICE.organization]: '/organization-courses',
      [COURSE_SERVICE.supervisor]: '/teacher-courses',
      [COURSE_SERVICE.student]: '/student-courses',

      [COURSE_SERVICE.all]: '/courses',
    };

    return APIService.get(
      SERVICES[serviceType],
      { params, rOptions: { model: Course, many: true } },
    );
  },

  show(id, params) {
    return APIService.get(`/courses/${id}`, { params, rOptions: { model: Course } });
  },

  create(data, obs) {
    return APIService.post('/courses', data, { rOptions: { obs } });
  },

  update(id, data, obs) {
    return APIService.post(`/courses/${id}`, data, { rOptions: { obs } });
  },

  delete(id) {
    return APIService.delete(`/courses/${id}`);
  },

  /**
   * Получить список курсов. DEPRECATED - use index() instead
   *
   * @returns {Promise<AxiosResponse<T>>}
   */
  getCourseList(params) {
    const config = { params };
    return APIService.get('/courses', config);
  },

  /**
   * Получить список групп курса
   * @returns {Promise<AxiosResponse<T>>}
   */
  getCourseGroupList(courseId, params = {}) {
    return APIService.get(`/course/${courseId}/groups`, { params });
  },

  courseUnitIndex(courseId, params) {
    return APIService.get(`/courses/${courseId}/course-units`, {
      params,
      rOptions: {
        model: Unit,
        many: true,
        itemParse: (i) => ({ course_id: courseId, ...i }),
      },
    });
  },
  publicCourseUnitIndex(courseId, params) {
    return APIService.get(`public/courses/${courseId}/course-units`, {
      params,
      rOptions: {
        model: Unit,
        many: true,
        itemParse: (i) => ({ course_id: courseId, ...i }),
      },
    });
  },

  courseUnitShow(courseId, id, params) {
    return APIService.get(`/courses/${courseId}/course-units/${id}`, {
      params,
      rOptions: {
        model: Unit,
        itemParse: (i) => ({ course_id: courseId, ...i }),
      },
    });
  },

  /**
   * Обновление порядковых номеров тем (course_unit'ов) курса
   * @param array
   * @returns {Promise<AxiosResponse<T>>}
   */
  changeCourseUnitsOrder(courseId, array) {
    return APIService.post(`/courses/${courseId}/course-units/update-ordinals`, array);
  },

  /**
   * Получить максимальную длительность курса из всех курсов
   * @returns {Promise<AxiosResponse<T>>}
   */
  getMaxCourseDuration() {
    return APIService.get('/courses/max-duration');
  },

  /**
   * Получить токен курса
   * @returns {Promise<AxiosResponse<T>>}
   */
  getCourseToken(id) {
    return APIService.get(`/course/${id}/token`);
  },

  /**
   * Получить список программ и групп курса с ПФДО
   * @returns {Promise<AxiosResponse<T>>}
   */
  getCourseResources(id) {
    return APIService.get(`/course/${id}/pfdo-resource`);
  },

  /**
   * Обновить статус курса
   *
   * @param courseId
   * @param data
   * @returns {*}
   */
  updateStatus(courseId, data) {
    return APIService.post(`/course/${courseId}/update-status`, data);
  },

  /**
   * Прикрепить учителей к курсу
   *
   * @param courseId
   * @param data
   * @returns {Promise<AxiosResponse<T>>}
   */
  addTeachers(courseId, data) {
    return APIService.post(`/course/${courseId}/add-teachers`, data);
  },

  /**
   *
   * Отцепить учителей от курса
   * @param courseId
   * @param data
   * @returns {Promise<AxiosResponse<any>>}
   */
  removeTeachers(courseId, data) {
    return APIService.post(`/course/${courseId}/detach-teachers`, data);
  },

  /**
   * Привязать группы к курсу
   *
   * @param {number} courseId
   * @param {Array<number>} groupIds
   * @returns {Promise<AxiosResponse<T>>}
   */
  bindGroupsToCourse(courseId, groupIds) {
    return APIService.post(`/course/${courseId}/add-groups`, { groups: groupIds });
  },

  /**
   * Получить расписание
   */
  getSchedule() {
    return APIService.get('/courses/schedule');
  },

  changeStatus(courseId, status) {
    return APIService.put(`/course/${courseId}/change-status`, { status });
  },

  cloneCourse(courseId) {
    return APIService.get(`/courses/${courseId}/clone`);
  },

  /**
   * Проверка заполненности аттрибутов
   *
   */
  // checkAttributes(courseId) {
  //   return APIService.get(`/courses/${courseId}/check-attribute`);
  // },
  checkAttributes(id) {
    return APIService.get(`/prior-records/${id}/check-attribute`);
  },

  // Сотрудники
  staffRecordsMake(courseId, params) {
    return APIService.post(`/course/${courseId}/prior-record/request`, params);
  },
  staffRecordsShow(enrollmentId, params) {
    return APIService.get(`/prior-records/${enrollmentId}/request `, params);
  },
  staffRecordsRemoveUser(courseId, userId) {
    return APIService.delete(`/course/${courseId}/prior-record/request/user/${userId}`);
  },
  staffRecordsSubmit(enrollmentId, requestId) {
    return APIService.post(`/prior-records/${enrollmentId}/prior-record-requests/${requestId}/sign-up`);
  },
  staffRecordsSaveAttributes(recordId, data) {
    return APIService.post(`/courses/prior-record/${recordId}/attributes`, data);
  },
  recordsAddUser(courseId) {
    return APIService.get(`/course/${courseId}/prior-record/add-user`);
  },

  // Конструктор
  constructorGet(courseId, params) {
    return APIService.get(`/courses/${courseId}/constructor`, { params });
  },
  constructorSave(courseId, data) {
    return APIService.post(`/courses/${courseId}/constructor`, data);
  },

  availableTypes(data) {
    return APIService.get('/courses/available-types', data);
  },
};
